/* eslint-disable linebreak-style */
//--------------------------------------------------------------------------------------------
export const mpJV=(vLungime=0, vInaltime=0,vDeschidere=0)=>{
  switch(vInaltime*1){
    case 0:
      return (vLungime / 1000).toFixed(2)
    default:
      if(vDeschidere==='L'){
        return ((vLungime * 116 * (vInaltime > 2000 ? vInaltime*1 : 2000) * 6 / 10) / 1000000).toFixed(2)
      }else{
        return (vLungime * (vInaltime > 2000 ? vInaltime*1 : 2000) / 1000000).toFixed(2)
      }
  }
}
//--------------------------------------------------------------------------------------------
export const actJV=(vInaltime=0)=>{
  switch(true){
    case (vInaltime <=0):
      return 1500
    case (vInaltime > 0 && vInaltime <= 800):
      return 800
    case (vInaltime > 800 && vInaltime <= 900) :
      return (vInaltime / 100).toFixed(0)
    case (vInaltime > 900 && vInaltime <= 1200) :
      return ((vInaltime - 100) / 100).toFixed(0) * 100
    case (vInaltime > 1200 && vInaltime <= 2000) :
      return ((vInaltime*1 - 200) / 100).toFixed(0) * 100
    case (vInaltime > 2000) :
      return ((vInaltime*1 - 300) / 100).toFixed(0) * 100
    default:
      return 0
  } 
}


export const pretJV=(vMP=0,vPretMaterial=0,vConsole=0,vPretConsole=0,vNumarCarucioare=0,vOptional2=0,vPretOptional2=0, vLungime=0,vDeschidere="",vBuc,vPretCardanPrelungitor45=0)=>{
  let Pret=0
  const pretActionare =(vDeschidere==="DA"?40:0) // COST SUPLIMENTAR ACTIONARE DA : 40 LEI/BUC

  switch(vOptional2){
    case 9: // inclinata
      Pret=(vMP * vPretMaterial * 1.5) + (vConsole * vPretConsole)+ (vNumarCarucioare * vPretCardanPrelungitor45)
      console.log('Pret', Pret)
      break;
    case 6:// umerase reglabile
      Pret=(vMP * vPretMaterial) + (vConsole * vPretConsole)+ (vNumarCarucioare * vPretOptional2)
      break;
    case 10://sine colorate
    case 11:
    case 14:
    case 15:
    case 19:
    case 20:
    case 21:
      Pret=(vMP * vPretMaterial) + (vConsole * vPretConsole)+ (vLungime/1000 * vPretOptional2)
      break;
    default:
      Pret=(vMP * vPretMaterial) + (vConsole * vPretConsole)+  1*vPretOptional2
      break;
  }
 
  return ((Pret*1 + pretActionare*1) * vBuc).toFixed(2)
}
//--------------------------------------------------------------------------------------------

export const carucioareJV = (vLungime=0, vDeschidere='0', vTipMaterial='0', vTipSubprodus='0') => {
  let paritate;
  switch(vTipSubprodus){
    case 1: // Jaluzele verticale 127
        switch(vDeschidere){
          case '1':
          case '2':
          case 'DA':
            return round49( vLungime*1 / 116 )
          case '3':
            paritate=round40( (vLungime*1) / 116 ) % 2 === 0 ? 0 : 1
            if(paritate===0){
              return round40( (vLungime*1) / 116 )
            }else{
              return round40( (vLungime*1) / 116 ) + 1
            }
          case '4':
            paritate=round49( (vLungime*1) / 116 ) % 2 === 0 ? 0 : 1
            if(paritate===0){
              return round49( (vLungime*1) / 116 )
            }else{
              return round49( (vLungime*1) / 116 ) + 1
            }
          case 'L':
            return round49(vLungime*1)
          default:
            return 0
        }
    case 2: // Jaluzele verticale 89
      switch(vDeschidere){
        case '1':
        case '2':
        case 'DA':
          return round40( (vLungime*1 - 20) / 81 );
        case '3':
          paritate=round40( (vLungime*1 - 20) / 81 ) % 2 === 0 ? 0 : 1;
          if(paritate===0){
            return round40( (vLungime*1 - 20) / 81 );
          }else{
            return round40( (vLungime*1 - 20) / 81 ) + 1;
          }
        case '4':
          paritate=round49( (vLungime*1 - 20) / 81 ) % 2 === 0 ? 0 : 1;
          if(paritate===0){
            return round49( (vLungime*1 - 20) / 81 );
          }else{
            return round49( (vLungime*1 - 20) / 81 ) + 1;
          }
        case 'L':
          return round49(vLungime*1);
        default:
          return 0
      }
    case 3: // Jaluzele tip perdea 127
      switch(vDeschidere){
        case '1':
        case '2':
        case 'DA':
          return round49( vLungime*1 / 116 )
        case '3':
          paritate=round40( (vLungime*1) / 116 ) % 2 === 0 ? 0 : 1
          if(paritate===0){
            return round40( (vLungime*1) / 116 )
          }else{
            return round40( (vLungime*1) / 116 ) + 1
          }
        case '4':
          paritate=round49( (vLungime*1) / 116 ) % 2 === 0 ? 0 : 1
          if(paritate===0){
            return round49( (vLungime*1) / 116 )
          }else{
            return round49( (vLungime*1) / 116 ) + 1
          }
        case 'L':
          return round49(vLungime*1)
        default:
          return 0
      }
    case 4: // Jaluzele tip perdea89
      switch(vDeschidere){
        case '1':
        case '2':
        case 'DA':
          return round40( (vLungime*1 - 20) / 81 );
        case '3':
          paritate=round40( (vLungime*1 - 20) / 81 ) % 2 === 0 ? 0 : 1;
          if(paritate===0){
            return round40( (vLungime*1 - 20) / 81 );
          }else{
            return round40( (vLungime*1 - 20) / 81 ) + 1;
          }
        case '4':
          paritate=round49( (vLungime*1 - 20) / 81 ) % 2 === 0 ? 0 : 1;
          if(paritate===0){
            return round49( (vLungime*1 - 20) / 81 );
          }else{
            return round49( (vLungime*1 - 20) / 81 ) + 1;
          }
        case 'L':
          return round49(vLungime*1);
        default:
          return 0
      }
    case 5: // Jaluzele tip Idilia (89)
    case 9: // Jaluzea Idilia BO
        switch(vDeschidere){
          case '1':
          case '2':
          case 'DA':
            return round40( (vLungime*1 - 20) / 81 );
          case '3':
            paritate=round40( (vLungime*1 - 20) / 81 ) % 2 === 0 ? 0 : 1;
            if(paritate===0){
              return round40( (vLungime*1 - 20) / 81 );
            }else{
              return round40( (vLungime*1 - 20) / 81 ) + 1;
            }
          case '4':
            paritate=round49( (vLungime*1 - 20) / 81 ) % 2 === 0 ? 0 : 1;
            if(paritate===0){
              return round49( (vLungime*1 - 20) / 81 );
            }else{
              return round49( (vLungime*1 - 20) / 81 ) + 1;
            }
          case 'L':
            return round49(vLungime*1);
          default:
            return 0
        }
    case 6: // Garnisa 127
      switch(vDeschidere){
        case '1':
        case '2':
        case 'DA':
          return round49( vLungime*1 / 116 )
        case '3':
          paritate=round40( (vLungime*1) / 116 ) % 2 === 0 ? 0 : 1
          if(paritate===0){
            return round40( (vLungime*1) / 116 )
          }else{
            return round40( (vLungime*1) / 116 ) + 1
          }
        case '4':
          paritate=round49( (vLungime*1) / 116 ) % 2 === 0 ? 0 : 1
          if(paritate===0){
            return round49( (vLungime*1) / 116 )
          }else{
            return round49( (vLungime*1) / 116 ) + 1
          }
        case 'L':
          return round49(vLungime*1)
        default:
          return 0
      }
    case 7: // Garnisa 89
      switch(vDeschidere){
        case '1':
        case '2':
        case 'DA':
          return round40( (vLungime*1 - 20) / 81 );
        case '3':
          paritate=round40( (vLungime*1 - 20) / 81 ) % 2 === 0 ? 0 : 1;
          if(paritate===0){
            return round40( (vLungime*1 - 20) / 81 );
          }else{
            return round40( (vLungime*1 - 20) / 81 ) + 1;
          }
        case '4':
          paritate=round49( (vLungime*1 - 20) / 81 ) % 2 === 0 ? 0 : 1;
          if(paritate===0){
            return round49( (vLungime*1 - 20) / 81 );
          }else{
            return round49( (vLungime*1 - 20) / 81 ) + 1;
          }
        case 'L':
          return round49(vLungime*1);
        default:
          return 0
      }
    default: // Jaluzea veche neidentificata
        if (vTipMaterial==='89'){
          switch(vDeschidere){
            case '1':
            case '2':
            case 'DA':
              return round40( (vLungime*1 - 20) / 81 );
            case '3':
              paritate=round40( (vLungime*1 - 20) / 81 ) % 2 === 0 ? 0 : 1;
              if(paritate===0){
                return round40( (vLungime*1 - 20) / 81 );
              }else{
                return round40( (vLungime*1 - 20) / 81 ) + 1;
              }
            case '4':
              paritate=round49( (vLungime*1 - 20) / 81 ) % 2 === 0 ? 0 : 1;
              if(paritate===0){
                return round49( (vLungime*1 - 20) / 81 );
              }else{
                return round49( (vLungime*1 - 20) / 81 ) + 1;
              }
            case 'L':
              return round49(vLungime*1);
            default:
              return 0
          }
          
        }else{
      
          switch(vDeschidere){
            case '1':
            case '2':
            case 'DA':
              return round49( vLungime*1 / 116 )
            case '3':
              paritate=round40( (vLungime*1) / 116 ) % 2 === 0 ? 0 : 1
              if(paritate===0){
                return round40( (vLungime*1) / 116 )
              }else{
                return round40( (vLungime*1) / 116 ) + 1
              }
            case '4':
              paritate=round49( (vLungime*1) / 116 ) % 2 === 0 ? 0 : 1
              if(paritate===0){
                return round49( (vLungime*1) / 116 )
              }else{
                return round49( (vLungime*1) / 116 ) + 1
              }
            case 'L':
              return round49(vLungime*1)
            default:
              return 0
          }
        }
  }
  
}

//----------------------------------------------------------------------------------------------

export const round49 = (n=0) => {
  let nr = n*1 - Math.floor(n)
  if(nr<=49/100){
    return Math.floor(n)
  }else{
    return Math.floor(n) + 1
  }
}

//----------------------------------------------------------------------------------------------
export const round40 = (n=0) => {
  let nr =  n*1 - Math.floor(n);
  if(nr<=40/100){
    return Math.floor(n)
  }else{
    return Math.floor(n) + 1
  }
}
